import { render, staticRenderFns } from "./ViewMethodSampleSize.vue?vue&type=template&id=f22e1a56"
import script from "./ViewMethodSampleSize.vue?vue&type=script&lang=js"
export * from "./ViewMethodSampleSize.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports